@if (serviceStateVM$ | async; as vm) {
    @if (asset?.video) {
        @if (loading) {
            <div class="loading-container flex align-center justify-center">
                <mat-progress-spinner
                    class="example-margin"
                    mode="indeterminate">
                </mat-progress-spinner>
            </div>
        }

        <div class="flex justify-center align-items-center content">
            <video
                #video
                preload="auto"
                playsinline=""
                crossorigin="anonymous"
                [muted]="(videoState$ | async)?.isMuted"
                [loop]="(videoState$ | async)?.isLooping && isActive"
                (loadedmetadata)="applyReviewState(null)"
                (play)="play()"
                (pause)="pause()"
                (click)="clickHandler(vm.presentingState)"
                [src]="asset?.video"
                [style.width.px]="xform.elements[0][0]"
                [style.height.px]="xform.elements[1][1]"
            ></video>
        </div>
    } @else {
        <frog-video-processing
            class="flex"
            [assetName]="asset?.name"
            [uploaderName]="asset?.author?.name"
            [failed]="!!((failedAssetIds$ | async)?.has(asset?.id))"
        ></frog-video-processing>
    }
}
@if (playbackState$ | async) {}
